/**
 * The page's entry: mounts the Console into #lfoc-root.
 *
 * The production page (src/index.html) and the dev page (dev/index.html) both
 * load this, so the Console starts the same way in both. It used to be mounted
 * by a separate host shell (apps/console-host) that checked a signed manifest
 * first; that shell was removed, and the browser's own Subresource Integrity
 * check on the script tags now covers what it loaded (rspack.config.mjs).
 */
import { mount } from './index.js';

const root = document.getElementById('lfoc-root');
try {
  // The Console API is on the Console's own origin.
  mount(root, { apiBase: '/api' });
} catch (error) {
  // Fail visibly. A blank screen sends the operator to the wrong person.
  if (root) root.textContent = 'Fund Operations could not start: ' + error.message;
  console.error(error);
}
